export default __webpack_public_path__ + "static/media/notification.0a8b6eeb.mp3";